import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
    return (
        <footer id="infocolors-footer" data-appear="fade-up" data-unload="fade-down">
            <div className="infocolors-footer-widgets">
                <div className="stg-container">
                    <div className="stg-row" data-stagger-appear="fade-left" data-stagger-delay="100">
                        <div className="stg-col-5 stg-tp-col-12 stg-tp-bottom-gap-l">
                            <div className="infocolors-info-widget">
                                <Link to="/" className="infocolors-logo footer-logo">
                                    <img src="/img/logo.png" alt="infocolors." width="88" height="24" />
                                </Link>
                                <div className="infocolors-info-description">INFOCOLORS is a dynamic multi-platform media brand that is dedicated to connecting people to the creative and artistic part of the world. Our mission is not only to showcase talent but to empower creativity worldwide by establishing platforms for expression and fostering partnerships with diverse creative voices.</div>
                                <span className="infocolors-label">Follow us:</span>
                                <ul className="infocolors-socials-list" data-stagger-appear="fade-up" data-stagger-delay="75">
                                    <li>
                                        <Link to="https://web.facebook.com/the.infocolors" target="_blank" className="infocolors-socials-facebook">
                                            <i></i>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="https://www.instagram.com/the_infocolors/" target="_blank" className="infocolors-socials-instagram">
                                            <i></i>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="https://x.com/the_infocolors" target="_blank" className="infocolors-socials-x">
                                            <i></i>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="https://www.tiktok.com/@the_infocolors?lang=en" target="_blank" className="infocolors-socials-tiktok">
                                            <i></i>
                                        </Link>
                                    </li>
                                   {/*  <li>
                                        <Link to="#" target="_blank" className="infocolors-socials-patreon">
                                            <i></i>
                                        </Link>
                                    </li> */}
                                </ul>
                            </div>
                        </div>
                        <div className="stg-col-2 stg-offset-1 stg-tp-col-4 stg-m-col-4">
                            <div className="infocolors-widget">
                                <h6>Services</h6>
                                <div className="infocolors-menu-widget">
                                    <ul>
                                        <li><Link to="/">Photography</Link></li>
                                        <li><Link to="/">Videography</Link></li>
                                        <li><Link to="/">Ads & Professional content</Link></li>
                                        <li><Link to="/">Content creation</Link></li>
                                        <li><Link to="/">Phot Editing</Link></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="stg-col-2 stg-tp-col-4 stg-m-col-4">
                            <div className="infocolors-widget">
                                <h6>About Us</h6>
                                <div className="infocolors-menu-widget">
                                    <ul>
                                        <li><Link to="/about">About Us</Link></li>
                                        <li><Link to="/">Testimonials</Link></li>
                                        <li><Link to="/contact">Get in Touch</Link></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="stg-col-2 stg-tp-col-4 stg-m-col-4">
                            <div className="infocolors-widget">
                                <h6>Resources</h6>
                                <div className="infocolors-menu-widget">
                                    <ul>
                                        <li><Link to="/">Pricing</Link></li>
                                        <li><Link to="/">Help Center</Link></li>
                                        <li><Link to="/services">Our Services</Link></li>
                                        <li><Link to="/">Terms of Use</Link></li>
                                        <li><Link to="/">Privacy Policy</Link></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="infocolors-footer-line stg-container">
                <div className="align-center">
                    Copyright &copy; 2025. All Rights Reserved.
                </div>
            </div>
        </footer>
    );
};

export default Footer;
